"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var es6_promise_1 = require("es6-promise");
var emptySuggestion = {
    defaultCity: false,
    city: "",
    cities: [],
    defaultState: false,
    state: "",
    states: [],
    defaultCounty: false,
    county: "",
    counties: [],
    defaultCountry: false,
    country: ""
};
function getAddressSuggestion(zipCode, getAddressSuggestion, address, suggestionState) {
    if (!zipCode) {
        return new es6_promise_1.Promise(function (resolve, reject) { return resolve(emptySuggestion); });
    }
    return getAddressSuggestion(zipCode)
        .then(function (response) {
        response = normalizeResults(response);
        var city = address.city;
        var defaultCity = false;
        if (!city || city === suggestionState.lastDefaultedCity) {
            defaultCity = true;
            city = response.defaultCity;
        }
        var state = address.state;
        var defaultState = false;
        if (!state || state === suggestionState.lastDefaultedState) {
            defaultState = true;
            state = response.defaultState;
        }
        var county = address.county;
        var defaultCounty = false;
        if (!county || county === suggestionState.lastDefaultedCounty) {
            defaultCounty = true;
            county = response.defaultCounty;
        }
        var country = address.country;
        var defaultCountry = false;
        if (!country || country === suggestionState.lastDefaultedCountry) {
            defaultCountry = true;
            country = response.country;
        }
        return {
            defaultCity: defaultCity,
            city: city,
            cities: response.cities,
            defaultState: defaultState,
            state: state,
            states: response.states,
            defaultCounty: defaultCounty,
            county: county,
            counties: response.counties,
            defaultCountry: defaultCountry,
            country: country
        };
    });
}
exports.getAddressSuggestion = getAddressSuggestion;
var emptyResults = {
    cities: [],
    counties: [],
    country: "",
    defaultCity: "",
    defaultCounty: "",
    defaultState: "",
    states: []
};
function normalizeResults(results) {
    results = results || emptyResults;
    return {
        cities: results.cities || [],
        counties: results.counties || [],
        country: results.country || "",
        defaultCity: results.defaultCity || "",
        defaultCounty: results.defaultCounty || "",
        defaultState: results.defaultState || "",
        states: results.states || []
    };
}
